import { useState } from 'react';
import { useGameStore } from '../stores/gameStore';
import type { ClientMessage } from '@wasted-games/shared';
import CountdownTimer from './CountdownTimer';

interface SubmissionProps {
  send: (msg: ClientMessage) => void;
}

function Submission({ send }: SubmissionProps) {
  const [dare, setDare] = useState('');
  const hasSubmitted = useGameStore((s) => s.hasSubmitted);
  const currentRound = useGameStore((s) => s.currentRound);
  const config = useGameStore((s) => s.config);
  const phaseStartTime = useGameStore((s) => s.phaseStartTime);

  const handleSubmit = () => {
    const trimmed = dare.trim();
    if (trimmed.length < 10 || trimmed.length > 200) return;

    send({
      type: 'action',
      action: {
        type: 'submit_dare',
        gameType: 'gambit',
        dare: trimmed,
      },
    });
  };

  if (hasSubmitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="text-5xl mb-4">{'\u2705'}</div>
          <h2 className="text-2xl font-bold mb-2">Dare Submitted!</h2>
          <p className="text-base-content/60 mb-6">Waiting for other players...</p>

          <span className="loading loading-dots loading-md text-primary" />

          {config.timeLimitSubmission && phaseStartTime && (
            <div className="mt-6 flex justify-center">
              <CountdownTimer
                startTime={phaseStartTime}
                duration={config.timeLimitSubmission}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full space-y-6">
        <div className="text-center">
          <div className="badge badge-primary badge-outline mb-3">Round {currentRound}</div>
          <h2 className="text-2xl font-bold">Submit a Dare</h2>
          <p className="text-base-content/60 mt-1">Be creative! Make it interesting.</p>
        </div>

        {config.timeLimitSubmission && phaseStartTime && (
          <div className="flex justify-center">
            <CountdownTimer
              startTime={phaseStartTime}
              duration={config.timeLimitSubmission}
            />
          </div>
        )}

        <div className="form-control">
          <textarea
            placeholder="Write a dare... (e.g. 'Do 20 pushups')"
            value={dare}
            onChange={(e) => setDare(e.target.value)}
            className="textarea textarea-bordered textarea-lg w-full h-32 text-lg"
            maxLength={200}
            autoFocus
          />
          <label className="label">
            <span className={`label-text-alt ${dare.trim().length < 10 ? 'text-warning' : 'text-success'}`}>
              {dare.trim().length}/200 {dare.trim().length < 10 ? `(min ${10 - dare.trim().length} more)` : ''}
            </span>
          </label>
        </div>

        <button
          onClick={handleSubmit}
          disabled={dare.trim().length < 10 || dare.trim().length > 200}
          className="btn btn-primary btn-lg w-full"
        >
          Submit Dare
        </button>
      </div>
    </div>
  );
}

export default Submission;
